import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'help_center-instant_answer_primary_cta-click';

/**
 * Primary CTA click event on instant answer during self-serve flow in help center
 */
export function trackHelpCenterInstantAnswerPrimaryCtaClick(
  cta_name: string,
  issue_type2: string,
  retailerToken: string,
  brandToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { cta_name, issue_type2, retailerToken, brandToken },
  });
}
